import { Component, AfterViewInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../../core/api.service';
import { FunctionsService } from '../../../core/global/functions.service';
import { UtilityService } from '../../../core/global/utility.service';

@Component({
  selector: 'app-dining-time-add-modal',
  templateUrl: './dining-time-add-modal.component.html',
  styleUrls: ['./dining-time-add-modal.component.sass']
})
export class DiningTimeAddModalComponent implements AfterViewInit {
  @Input() public item: any = {};
  timeObj: any = {}
  updateId: number;
  meridian = true;
  from_time = { hour: 1, minute: 30 };
  to_time = { hour: 13, minute: 30 };
  constructor(public activeModal: NgbActiveModal, private _adminService: ApiService, private _functions: FunctionsService, private _utility: UtilityService) { }
  ngAfterViewInit(): void {
    if (typeof this.item === 'object' && this.item !== null) {
      this.item.id = this.item?.id ?? '';
      this.updateId = this.item.id;
    } else {
      this.item = { id: '' };
    }
    if (this.item.id != '') {
      this.timeObj.from_time = this.item.from_time
      this.timeObj.to_time = this.item.to_time

      let from_time = (this.timeObj.from_time).split(':')
      this.from_time = { hour: parseInt(from_time[0]), minute: parseInt(from_time[1])}

      let to_time = (this.timeObj.to_time).split(':')
      this.to_time = { hour: parseInt(to_time[0]), minute: parseInt(to_time[1])}

      this.timeObj.updateId = this.item.id

    }
  }

  save() {
    var error = 0;
    if (!this.timeObj.from_time || this.timeObj.from_time.trim() == '') {
      error++;
      this._utility.toastWarning('Enter From Time');
    }
    else if (!this.timeObj.to_time || this.timeObj.to_time.trim() == '') {
      error++;
      this._utility.toastWarning('Enter To Time');
    }
    let url = 'qr/time/update';
    if (error == 0) {
      this._utility.showLoader()
      this._adminService.post(url, this.timeObj).subscribe(
        (response) => {
          this._utility.hideLoader()
          if (response.success == true) {
            this._utility.toastSuccess(response.message);
            this.activeModal.close(true);
          } else {
            this._utility.toastError(response.message);
          }
        },
        (error) => {
          this._utility.hideLoader()
          console.log(error);
        }
      );
    }
  }

  fromTimeChange() {
    let mysqlformatTime = ('0' + this.from_time['hour']).slice(-2) + ':' + ('0' + this.from_time['minute']).slice(-2);
    this.timeObj.from_time = mysqlformatTime
  }

  toTimeChange() {
    let mysqlformatTime = ('0' + this.to_time['hour']).slice(-2) + ':' + ('0' + this.to_time['minute']).slice(-2);
    this.timeObj.to_time = mysqlformatTime
  }
  
}
